import React, {useEffect, useState} from 'react'
import headerImg from '../../../../assets/images/bookPage/header.jpg'
import logoWhiteImg from '../../../../assets/images/bookPage/logo-white.svg'
import firstImg from '../../../../assets/images/bookPage/1.jpeg'
import secondImg from '../../../../assets/images/bookPage/2.jpeg'
import thirdImg from '../../../../assets/images/bookPage/3.jpeg'
import forthImg from '../../../../assets/images/bookPage/4.jpeg'

import {ScheduleShootButton} from "../home_page/homeStyle";
import {Link, withRouter} from "react-router-dom";
import {ROUTES} from "../../routes";
import {Difference} from "../pageComponents/Difference";
import {Footer} from "../pages/subdomain/Book/Footer";
import {closeProjectModal, openProjectModal} from "../../actions/landing_page_actions";
import {connect} from "react-redux";
import Modals from "../../containers/PublicRouteContainer/modals";
import { Helmet } from 'react-helmet-async';
import {HowItWorks} from "../pageComponents/HowItWorks";
import {WhiteContainer} from "../location_page_components/TopPhotographer/styles";
import {FeaturesList} from "../pageComponents/FeaturesList";
import { TestimonialsComponent2 } from '../home_page/homeComponents'

const BookLocationPage = (props) => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 750);
  const [locationData, setLocationData] = useState(null);

  // Extract slug from URL: /book-{slug}
  const pathSlug = props.location?.pathname?.replace(/^\/book-/, '') || '';

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 750);
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (pathSlug) {
      fetch(`/locations/${pathSlug}`)
        .then(r => r.ok ? r.json() : null)
        .then(data => { if (data) setLocationData(data); })
        .catch(() => {});
    }
  }, [pathSlug])

  const cityName = locationData?.city || '';
  const sampleListingUrl = locationData?.sample_listing_url || null;

  const onScheduleShoot = () => {
    if (props.currentUser){
      props.history.push("/create-project")
    } else {
      props.openNewModal()
    }
  }

  return <>
    <Helmet>
      <title>Book a Real Estate Photographer in {cityName || 'Your Area'} | Modern Angles</title>
      <link rel="canonical" href={window.location.href} />
      <meta
        name="description"
        content={`Book Top-Rated Photographers for Your ${cityName} Listings. Get Stunning Photos, Drone Shots, Videos, Floor Plans & Virtual Staging – Delivered within 24 Hours.`}
      />
    </Helmet>
    <Modals isLargeScreen={isLargeScreen}/>
    <div className="book-page">
      <div className="book-page-header">
        <Link to="/" className="book-page-header-logo">
          <img src={logoWhiteImg} />
        </Link>

        <img src={headerImg} className="book-page-header-bg"/>
      </div>

      <div className="book-page-header-container">
        <div className="book-page-header-container-inner">
          <div className="book-page-header-subtitle">{cityName} Real Estate:</div>
          <div className="book-page-header-title">
            <div>
              <div>Photography & Video</div>
            </div>
          </div>

          <div className="book-page-header-description">Professional photos, video & drone — delivered within 24 hours.
          </div>

          <div className="text-center">
            <ScheduleShootButton onClick={onScheduleShoot} className="mt-0">
              Schedule Shoot / Pricing
            </ScheduleShootButton>

            <Link to={ROUTES.CONTACTS} className="speak-to-our-team-link">
              Contact our team.
            </Link>

            {sampleListingUrl && (
              <div className="mt-3">
                <a href={sampleListingUrl} target="_blank" rel="noopener noreferrer" className="book-location-sample-listing-link">
                  View Sample {cityName} Listing Photoshoot
                </a>
              </div>
            )}
          </div>
        </div>

        <div className="lead-page-divider mb-0"/>

        <div className="book-page-header-container-inner">
          <FeaturesList />
        </div>

        <div className="lead-page-divider mb-0"/>

        <TestimonialsComponent2 bookPage={true}/>

      </div>
      <div className="lead-page-divider mb-0"/>

      <Difference noTopBorder={true}/>

      <div className="book-page-get-started-container">
        <div className="book-page-get-started-title">
          <span className="accent"> Get Listing Media </span><br/>That Sells Homes Faster
        </div>

        <div className="book-page-get-started-images">
          <img src={firstImg}/>
          <img src={secondImg}/>
          <img src={thirdImg}/>
          <img src={forthImg}/>
        </div>
      </div>

      <div className="scheduleButtonDiv">
        <ScheduleShootButton onClick={onScheduleShoot} className="mt-0">
          Schedule Shoot
        </ScheduleShootButton>
      </div>

      <WhiteContainer>
        <HowItWorks />
      </WhiteContainer>

      <Footer/>
    </div>
  </>
}

const msp = (state) => ({
  currentUser: state.session.currentUser ? state.entities.users[state.session.currentUser.id] : null
});

const mdp = (dispatch) => ({
  openNewModal: () => {
    dispatch(openProjectModal());
  },
  closeModal: () => {
    dispatch(closeProjectModal());
  },
});

export default withRouter(connect(msp, mdp)(BookLocationPage));
